import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function PublicServicesPage({ onBack, go }) {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const categories = [
    {
      slug: "temples",
      title: "Temples",
      description: "Temples and places of worship in and around Vijayanagar.",
      icon: <Building2 size={28} />,
    },
    {
      slug: "hospitals",
      title: "Hospitals",
      description: "Hospitals and healthcare facilities available to residents.",
      icon: <Building2 size={28} />,
    },
    {
      slug: "police-stations",
      title: "Police Stations",
      description: "Police stations and local public safety information.",
      icon: <ShieldCheck size={28} />,
    },
    {
      slug: "libraries",
      title: "Libraries",
      description: "Libraries and public learning resources in the area.",
      icon: <FileText size={28} />,
    },
    {
      slug: "schools",
      title: "Schools",
      description: "Schools and public education-related information.",
      icon: <Building2 size={28} />,
    },
  ];

  useEffect(() => {
    api.get("/services")
      .then((r) => {
        setServices(r.data.items || r.data || []);
      })
      .catch(() => {
        setServices([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const getCount = (slug) => {
    const keywords = {
      temples: ["temple", "temples", "mandir"],
      hospitals: ["hospital", "hospitals", "healthcare", "medical"],
      "police-stations": ["police", "police station", "police stations"],
      libraries: ["library", "libraries"],
      schools: ["school", "schools", "education"],
    };

    return services.filter((item) => {
      const category = String(item.category || "").toLowerCase().trim();

      if (category === slug) return true;

      const text = [
        item.name,
        item.title,
        item.description,
        item.category,
        item.type,
        item.service_type,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return keywords[slug].some((keyword) => text.includes(keyword));
    }).length;
  };

  return (
    <SimplePage title="Public Services" onBack={onBack}>
      <div className="services-modern">

        <section className="services-modern-hero">
          <div className="services-modern-hero-copy">
            <span className="eyebrow">PUBLIC SERVICES · VIJAYANAGAR</span>

            <h2>
              Find the places and services
              <span> you need nearby.</span>
            </h2>

            <p>
              Browse local public-service information by category. Find
              useful places, contact details, addresses and opening hours
              from one convenient portal.
            </p>
          </div>

          <div className="services-modern-hero-mark">
            <Building2 size={42} />
            <span>5</span>
            <small>service categories</small>
          </div>
        </section>

        <section className="services-category-section">
          <div className="services-section-heading">
            <div>
              <span className="eyebrow">EXPLORE</span>
              <h2>Public Services</h2>
            </div>

            <p>
              Select a category to view available places and information.
            </p>
          </div>

          <div className="services-category-grid">
            {categories.map((category, index) => (
              <button
                type="button"
                key={category.slug}
                className="services-category-card"
                onClick={() => go(`/services/${category.slug}`)}
              >
                <div className="services-category-top">
                  <span className="services-category-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span className="services-category-arrow">
                    <ArrowRight size={18} />
                  </span>
                </div>

                <div className="services-category-icon">
                  {category.icon}
                </div>

                <div className="services-category-body">
                  <h3>{category.title}</h3>
                  <p>{category.description}</p>
                </div>

                <div className="services-category-footer">
                  <span>
                    {loading
                      ? "Loading..."
                      : `${getCount(category.slug)} ${getCount(category.slug) === 1 ? "listing" : "listings"}`}
                  </span>

                  <strong>
                    Explore <ArrowRight size={15} />
                  </strong>
                </div>
              </button>
            ))}
          </div>
        </section>

        <section className="services-info-strip">
          <div className="services-info-icon">
            <ShieldCheck size={20} />
          </div>

          <div>
            <strong>Public information directory</strong>
            <p>
              Information displayed here is provided to help residents locate
              and access public services. Availability and timings may change,
              so residents should verify details where necessary.
            </p>
          </div>
        </section>

      </div>
    </SimplePage>
  );
}



function ServicesPage(props) { return <PublicServicesPage {...props} />; }
export default ServicesPage;
